module.exports = __webpack_public_path__ + "static/media/copy_black.0ae11cce.svg";